module.exports = __webpack_public_path__ + "img/Doc10-19990092-068_eng.1f5d308b.jpg";